import AuthContext from "app/contexts/JWTAuthContext";
import { useContext } from "react";

const useAuth = () => useContext(AuthContext);
export default useAuth;
